export default __webpack_public_path__ + "static/media/Group1031.3f45024e.svg";